import { useQuery, type UseQueryResult } from "@tanstack/react-query";
import type { AxiosError } from "axios";

import { appliesQueryKeys } from "./query-keys";
import type { AppliesCockpitInfo } from "./types";

import { instance } from "@/lib/axios/instance";

type UseApplyCockpitOptions = {
  enabled?: boolean;
};

export function useApplyCockpit(
  applyId: string | undefined,
  options: UseApplyCockpitOptions = {},
): UseQueryResult<AppliesCockpitInfo | null, AxiosError> {
  const enabled = (options.enabled ?? true) && !!applyId;

  return useQuery({
    queryKey: appliesQueryKeys.cockpit(applyId!),
    queryFn: () =>
      instance
        .get<AppliesCockpitInfo | null>(`/api/v2/Applies/${applyId}/Cockpit`)
        .then((res) => res.data),
    enabled,
    staleTime: 5 * 60 * 1000,
  });
}
